<template>
  <div class="side-menu-options is-props-col use-bscroll" style="background:white">

    <div style="margin:10px">

         <component
            v-bind:is = "this.currentTabComponent"
            v-bind:bezieAppObj = "this.bezieAppObj"
          ></component>

    </div>

  </div>
</template>

<script>
import UploadsSideMenu from './UploadsSideMenu.vue'
import ShapesSideMenu from './ShapesSideMenu.vue'
import TextSideMenu from './TextSideMenu.vue'
import ElementsSideMenu from './ElementsSideMenu.vue'
import LayersSideMenu from './LayersSideMenu.vue'
import PropertySideMenu from './PropertySideMenu.vue'

export default {
  name: 'SideMenuOptions',
  props: ['selectedTab','bezieAppObj'],
  components: {
    UploadsSideMenu,
    ShapesSideMenu,
    TextSideMenu,
    ElementsSideMenu,
    LayersSideMenu,
    PropertySideMenu
  },
  computed: {
    currentTabComponent: function () {
      return this.selectedTab+'SideMenu';
    }
  }
}
</script>

<style scoped>
.is-props-col{
  width: 400px;
  height: 100%;
  overflow-y: hidden;
}

.is-props-col:hover {
  overflow-y: overlay;
}

</style>